import { Popper, styled } from "@mui/material";

const DatepickerPopper = styled(Popper)(({ theme }) => ({
  zIndex: 2000,
  "& .MuiPaper-root.MuiPickersPopper-paper": {
    backgroundColor: theme.palette.primary.main
  },

  "& .MuiPickersCalendarHeader-root": {
    margin: 0,
    padding: theme.spacing(1.75, 2.75),
    textTransform: "capitalize",
    position: "relative",

    "& .MuiPickersArrowSwitcher-root": {
      width: 0,
    },
    "& .MuiPickersCalendarHeader-labelContainer": {
      margin: "auto",
      fontWeight: theme.typography.fontWeightRegular,

      "& .MuiPickersCalendarHeader-label": {
        margin: 0,
      },
    },
    "& .MuiIconButton-edgeEnd": {
      position: "absolute",
      left: 0,
      top: 7,
      bottom: 0,
      color: theme.palette.secondary.main,

      "&.Mui-disabled": {
        color: theme.palette.secondary.dark,
      },
    },
    "& .MuiIconButton-edgeStart": {
      position: "absolute",
      right: 0,
      top: 7,
      bottom: 0,
      color: theme.palette.secondary.main,

      "&.Mui-disabled": {
        color: theme.palette.secondary.dark,
      },
    },
  },

  "& .MuiDayCalendar-root": {
    padding: theme.spacing(1.75),
  },

  "& .MuiDayCalendar-weekContainer, & .MuiDayCalendar-header": {
    justifyContent: "space-between",
  },

  "& .MuiDayCalendar-weekContainer": {
    "& .MuiButtonBase-root": {
      width: 30,
      height: 34,
      fontSize: 14,
      margin: theme.spacing(0.5),
      fontWeight: theme.typography.fontWeightMedium,
      borderRadius: 0,

      "&:hover, &:focus, &:active": {
        outline: "none",
        borderWidth: 1,
        borderStyle: "solid",
        borderColor: theme.palette.success.main,
        color: theme.palette.success.main,
      },

      "&.Mui-selected": {
        backgroundColor: theme.palette.success.main,
        color: theme.palette.text.secondary,
        "&.MuiPickersDay-dayOutsideMonth": {
          color: theme.palette.text.secondary,
        },
      },

      "&.Mui-selected:hover, &.Mui-selected:focus, &.Mui-selected:active": {
        color: theme.palette.text.secondary,
      },

      "&.Mui-disabled": {
        color: theme.palette.primary.light,
      },

      "&.MuiPickersDay-dayOutsideMonth": {
        color: theme.palette.text.primary,
      },

      "&.Mui-disabled.MuiPickersDay-dayOutsideMonth": {
        color: theme.palette.primary.light,
      },
    },
  },

  "& .MuiDayCalendar-header": {
    "& .MuiTypography-root.MuiTypography-caption": {
      color: theme.palette.primary.contrastText,
      fontWeight: theme.typography.fontWeightMedium,
      textTransform: "capitalize",
      fontSize: 14,
    },
  },
}));

export default DatepickerPopper;
